import { AuthStorage, AuthTokens } from '@capiche/ts-auth-core';

const KEY = 'capiche-auth-tokens';

export const localStorageAdapter: AuthStorage = {
  async getTokens(): Promise<AuthTokens | null> {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  },
  async saveTokens(tokens: AuthTokens): Promise<void> {
    localStorage.setItem(KEY, JSON.stringify(tokens));
  },
  async clearTokens(): Promise<void> {
    localStorage.removeItem(KEY);
  },
};
